module.exports = __webpack_public_path__ + "img/thumb3-bg@2x.7bb0246a.png";